module.exports = __webpack_public_path__ + "img/cards1_front19.cd77361c.png";